import React, { useLayoutEffect } from 'react';
import { SWRConfig } from 'swr';
import { StylesProvider } from '@material-ui/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { ThemeProvider } from 'styled-components';
import { Provider, useSelector } from 'react-redux';
import GlobalStyle from 'common/styles/styles';
import muiTheme from 'common/styles/mui-theme';
import extendealTheme from 'common/styles/extendeal-theme';
import './common/language/i18n';
import AppRouter from 'common/router';
import store from 'common/redux/store';
import { AlertProvider } from 'context';
import { apiFetcher } from 'common/utils/axios';
import { currentUserSelector } from 'common/redux/global/selectors';
import {
  applyTheme,
  getDocumentTheme,
  getStoredTheme,
  getUserTheme,
  wasThemeManuallySet
} from 'common/utils/helpers';

/**
 * Sincroniza el tema del usuario al documento.
 * El toggle del menú usa applyTheme({ manual: true }) y no re-renderiza el árbol.
 */
function ThemeDocumentSync() {
  const currentUser = useSelector(currentUserSelector);

  useLayoutEffect(() => {
    if (wasThemeManuallySet()) {
      return;
    }

    const fromUser = getUserTheme(currentUser);
    if (fromUser) {
      applyTheme(fromUser);
      return;
    }

    if (!getDocumentTheme()) {
      const stored = getStoredTheme();
      if (stored) {
        applyTheme(stored);
      }
    }
  }, [currentUser]);

  return null;
}

export default function App() {
  return (
    <Provider store={store}>
      <StylesProvider injectFirst>
        <MuiThemeProvider theme={muiTheme}>
          <GlobalStyle />
          <ThemeProvider theme={extendealTheme}>
            <SWRConfig
              value={{
                fetcher: apiFetcher,
                revalidateOnFocus: false
              }}
            >
              <AlertProvider>
                <ThemeDocumentSync />
                <AppRouter />
              </AlertProvider>
            </SWRConfig>
          </ThemeProvider>
        </MuiThemeProvider>
      </StylesProvider>
    </Provider>
  );
}
